"use client";

import { useEffect, useState } from "react";

import { useLaunchDarkly } from "#/store/app/integrations/launchDarkly";

export const useFeatureFlags = <T>(flag: string): T | undefined => {
  const { client } = useLaunchDarkly();
  const [value, setValue] = useState<T | undefined>(undefined);

  useEffect(() => {
    if (!client) return;

    const onReady = () => {
      setValue(client.variation(flag) as T | undefined);
    };

    const onChange = (settings: { [key: string]: { current: T } }) => {
      if (!settings[flag]) return;

      setValue(settings[flag].current as T | undefined);
    };

    client.on("ready", onReady);
    client.on("change", onChange);
    onReady();

    return () => {
      client.off("ready", onReady);
      client.off("change", onChange);
    };
  }, [client, flag]);

  return value;
};
